import { RouteObject } from "react-router-dom";
import { INVITATION, INVITATION_DETAIL } from "constants/urls";

export default [
  {
    index: true,
    path: INVITATION,
    lazy: () => import("modules/invitation/pages/InvitationList"),
  },
  {
    path: INVITATION_DETAIL,
    lazy: () => import("modules/invitation/pages/InvitationDetail"),
  },
] as RouteObject[];
